var transactionMap = {
  brand: 'brand',
  created_at: 'createdAt',
  delivery_method: 'deliveryMethod',
  handling_fee: 'handlingFee',
  hug_id: 'hugId',
  hugggs: 'hugggs',
  huggg_expiry: 'hugggExpiry',
  huggg_message: 'hugggMessage',
  id: 'id',
  maxHugggExpiryDate: 'maxHugggExpiryDate',
  merchant_fee: 'merchantFee',
  merchant_vat: 'merchantVat',
  notes: 'notes',
  notification_id: 'notificationId',
  notification_status: 'notificationStatus',
  notify_on_complete: 'notifyOnComplete',
  preview_shortcode: 'previewShortcode',
  processing: 'processing',
  product: 'product',
  purchased_at_date: 'purchasedAtDate',
  purchased_at_time: 'purchasedAtTime',
  quantity: 'quantity',
  reason_code: 'reasonCode',
  reference_id: 'referenceId',
  reference_type: 'referenceType',
  refunded: 'refundedCount',
  retail: 'retailPrice',
  sale_per_item: 'salePerItem',
  sale_quantity: 'saleQuantity',
  sale_total: 'saleTotal',
  status: 'status',
  stripe_fee: 'stripeFee',
  stripe_fee_refunded: 'stripeFeeRefunded',
  stripe_id: 'stripeId',
  superhuggg_expiry: 'superhugggExpiry',
  super_huggg_id: 'superhugggId',
  super_url_id: 'superUrlId',
  tag: 'tag',
  topup_type: 'topupType',
  updated_at: 'updatedAt',
  user: 'user',
  user_id: 'userId'
};
export default transactionMap;